// extracted by mini-css-extract-plugin
export default {"layout":"ChartLayout_layout__zCTgN","tab":"ChartLayout_tab__0A31f","tab_active":"ChartLayout_tab_active__8ztpA","chart_title":"ChartLayout_chart_title__y-gYe"};